import dynamic from "next/dynamic";
import Loading from "@/components/common/Loading";
import React from "react";

const DraggableLetters = dynamic(() => import("@/components/draggableLetters/DraggableLetters"), {
	loading: () => <Loading />,
	// ssr: false
})

const HeaderVariant = dynamic(() => import("@/components/Banners/SubPage/Variants/HeaderVariant"), {
	loading: () => <Loading />,
	// ssr: false
})

const CardAndImageVariant = dynamic(() => import("@/components/Banners/SubPage/Variants/CardAndImageVariant"), {
	loading: () => <Loading />,
	// ssr: false
})

const VideoNoButton = dynamic(() => import("@/components/Banners/SubPage/Variants/VideoNoButton"), {
	loading: () => <Loading />,
	// ssr: false
})

const ImageWithButtonToStartBackgroundVideo = dynamic(() => import("@/components/Banners/SubPage/Variants/ImageWithButtonToStartBackgroundVideo"), {
	loading: () => <Loading />,
	// ssr: false
})

const VideoWithButtonToStartFullScreenVideo = dynamic(() => import("@/components/Banners/SubPage/Variants/VideoWithButtonToStartFullScreenVideo"), {
	loading: () => <Loading />,
	// ssr: false
})

const VideoWithButtonToPlay = dynamic(() => import("@/components/Banners/SubPage/Variants/VideoWithButtonToPlay"), {
	loading: () => <Loading />,
	// ssr: false
})

const ImageWithThumbnailVideo = dynamic(() => import("@/components/Banners/SubPage/Variants/ImageWithThumbnailVideo"), {
	loading: () => <Loading />,
	// ssr: false
})

export const BANNER_VARIANTS = {
	TEXT: "TEXT",
	CARD_AND_IMAGE: "CARD_AND_IMAGE",
	DRAGGABLE_LETTERS: "DRAGGABLE_LETTERS",
	VIDEO_NO_BUTTON: "VIDEO_NO_BUTTON",
	VIDEO_WITH_BUTTON_TO_START_FULL_SCREEN_VIDEO: "VIDEO_WITH_BUTTON_TO_START_FULL_SCREEN_VIDEO",
	IMAGE_WITH_BUTTON_TO_START_BACKGROUND_VIDEO: "IMAGE_WITH_BUTTON_TO_START_BACKGROUND_VIDEO",
	IMAGE_WITH_THUMBNAIL_VIDEO: "IMAGE_WITH_THUMBNAIL_VIDEO",
	VIDEO_WITH_BUTTON_TO_PLAY: "VIDEO_WITH_BUTTON_TO_PLAY"
}

function BannerVariantSwitcher({ data }) {
	const variant = data?.variant?.variant || ''

	switch (variant) {
		case "":
			return <DraggableLetters data={data} />
		case BANNER_VARIANTS.TEXT:
			return <HeaderVariant data={data} />
		case BANNER_VARIANTS.CARD_AND_IMAGE:
			return <CardAndImageVariant data={data} />
		case BANNER_VARIANTS.VIDEO_NO_BUTTON:
			return <VideoNoButton data={data} />
		case BANNER_VARIANTS.VIDEO_WITH_BUTTON_TO_START_FULL_SCREEN_VIDEO:
			return <VideoWithButtonToStartFullScreenVideo data={data} />
		case BANNER_VARIANTS.IMAGE_WITH_BUTTON_TO_START_BACKGROUND_VIDEO:
			return <ImageWithButtonToStartBackgroundVideo data={data} />
		case BANNER_VARIANTS.IMAGE_WITH_THUMBNAIL_VIDEO:
			return <ImageWithThumbnailVideo data={data} />
		case BANNER_VARIANTS.VIDEO_WITH_BUTTON_TO_PLAY:
			return <VideoWithButtonToPlay data={data} />
		default:
			return null
	}
}

export default function SubPageBanner({ data }) {
	if (!data) return null

	return <BannerVariantSwitcher data={data} />
}
